var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{staticStyle:{"margin-top":"30px !important"},attrs:{"group":"notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }